export default "__VITE_ASSET__x1TdOZLa__"